import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';
import {
  getAllMenuItems, saveAllMenuItems, getAllItemTags, saveAllItemTags, deleteMenuItem, getAllDataOfCatalog,
  saveAllCatalogData, getGalleryImages, saveAllCategories, deleteCategoryData, saveUiAttributes, getUiAttributes, saveOptionsSet, getOptionsSets, updateItemData, getSingleItemData, setSingleItemData, saveCategoryData, updateCategoryData, getAllCategories
} from '../slices';
import { toastError } from "../../utils/react-toaster";
import { removeFalsyValues } from "../../helpers/common-helper";

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string,
  success?: boolean
  code?: any;
  results?: any;
  productvo?: any;
}

function* fetchAllCategories(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CATALOG.getAllCategoriesApi,
    })
    yield put(saveAllCategories(response));
  } catch (error) {
    console.log(error);
  }
}

function* fetchAllMenuItems(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CATALOG.menuItemsApi,
    })
    yield put(saveAllMenuItems(response));
  } catch (error) {
    console.log(error);
  }
}

function* fetchItemTags(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CATALOG.itemTagsApi,
    })
    yield put(saveAllItemTags(response));
  } catch (error) {
    console.log(error);
  }
}

function* deleteAMenuItem(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.CATALOG.deleteItemApi(actions.payload.data),
    });
    if (response?.code)
      actions.payload.callback(false);
    else
      actions.payload.callback(true);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

/**
 * This function will fetch all the catalog data
 */
function* fetchAllCatalogData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CATALOG.getAllData,
    })
    yield put(saveAllCatalogData(response));
    yield put(getAllCategories());
  } catch (error) {
    console.log(error);
  }
}

function* fetchAllGalleryImages(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CATALOG.getImageGalleryApi,
      data: actions.payload.dataToPost
    })
    if (response?.results) {
      actions.payload.callback && actions.payload.callback(response?.results);
    }
    // yield put(saveGalleryImages(response));
  } catch (error) {
    console.log(error);
  }
}

function* fetchUiAttributes(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CATALOG.uiAttributesApi,
    })
    yield put(saveUiAttributes(response));
  } catch (error) {
    console.log(error);
  }
}

/**
 * This will make an action to update a category data
 * @param actions 
 */
function* fetchOptionsSet(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CATALOG.getOptionsSetApi,
      data: actions.payload.dataToPost
    });
    if (actions.payload.dataToPost?.searchString)
      actions.payload.callback && actions.payload.callback(response || {});
    else
      yield put(saveOptionsSet(response));
  } catch (error) {
    toastError("Please try again");
    console.log(error);
  }
}

function* updateTheItemData(actions: any) {
  const data = actions.payload.dataToPost;
  if (!data.info.shortName)
    data.info.shortName = data.info.longName;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CATALOG.updateItemApi,
      data: removeFalsyValues(actions.payload.dataToPost)
    });
    if (response?.success) {
      // yield put(getSingleItemData({ itemID: data.mid }));
      actions.payload.callback && actions.payload.callback(response || {});
    }
    else
      toastError("Please try again!");

  } catch (error) {
    toastError("Please try again");
    console.log(error);
  }
}

function* fetchSingleItemData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CATALOG.getSingleItemDataApi(actions.payload.itemID),
    })
    if (response) {
      actions.payload.callback && actions.payload.callback(response);
      yield put(setSingleItemData(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* saveTheCategoryData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CATALOG.saveCategoryDataApi,
      data: removeFalsyValues(actions.payload.dataToPost)
    })
    if (response) {
      if (response?.code) {
        toastError("Please try again!");
      } else {
        actions.payload.callback && actions.payload.callback(response);
        yield put(updateCategoryData({ data: response }));
        // yield put(getAllCategories());
      }
    }
  } catch (error) {
    toastError("Please try again!");
    console.log(error);
  }
}

function* deleteCategory(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.CATALOG.deleteCategory(actions.payload.data),
    });
    if (response?.code)
      actions.payload.callback(false);
    else {
      actions.payload.callback && actions.payload.callback(true);
      yield put(updateCategoryData({ data: { mid: actions.payload.data }, type: "DELETE" }));
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getAllMenuItems.type, fetchAllMenuItems);
  yield takeEvery(getAllItemTags.type, fetchItemTags);
  yield takeEvery(deleteMenuItem.type, deleteAMenuItem);
  yield takeEvery(getAllDataOfCatalog.type, fetchAllCatalogData);
  yield takeEvery(getGalleryImages.type, fetchAllGalleryImages);
  yield takeEvery(getUiAttributes.type, fetchUiAttributes);
  yield takeEvery(getOptionsSets.type, fetchOptionsSet);
  yield takeEvery(updateItemData.type, updateTheItemData);
  yield takeEvery(getSingleItemData.type, fetchSingleItemData);
  yield takeEvery(saveCategoryData.type, saveTheCategoryData);
  yield takeEvery(deleteCategoryData.type, deleteCategory);
  yield takeEvery(getAllCategories.type, fetchAllCategories);
}

